
    import has from 'lodash/has';
    import numeral from 'numeral';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import JobViewPayTable from '@/components/JobView/JobViewPayTable';
    import FeatureFeedback from '@/components/Feedback/FeatureFeedback';
    import Histogram from '@/components/JobView/Histogram/Histogram';
    import SeekerPayBand from '@/components/Seeker/SeekerPayBand';

    export default {
        name: 'JobViewChartModal',

        components: {
            JobViewPayTable,
            FeatureFeedback,
            Histogram,
            SeekerPayBand,
        },

        props: {
            table: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                mutableTable: [],
                isOpen: false,
                yourPredictedProfileValue: 0,
                yourPredictedProfileValueLabel: '',
                modal: [
                    {
                        key: 'pay_comparison',
                        title: 'Pay insights',
                        is_active: true,
                    },
                    {
                        key: 'desired_pay',
                        title: 'Set your desired minimum pay',
                        is_active: false,
                    },
                ],
                spinner: {
                    profile_value: false,
                    pay_band: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_workExperience: state => state.me.workExperience,
            }),

            ...mapGetters('job', {
                $_isPayTypeAnnual: 'isPayTypeAnnual',
            }),

            hasSeekerDesiredPay() {
                return has(this.$_me, 'minPayBand.value') && this.$_me.minPayBand.value !== '-1.00';
            },

            seekerDesiredPay() {
                if (!this.hasSeekerDesiredPay) {
                    return false;
                }

                let annualPay = `${numeral(this.$_me.minPayBand.value).format('$0a')}`;
                let hourPay = `$${numeral(this.$_me.minPayBand.value).format('0')}/hr`;

                if (this.$_me.minPayBand.pay_type_id === 1 && this.$_me.minPayBand.value >= 350000) {
                    annualPay = `${numeral(350000).format('$0a')}+`;
                } else if (this.$_me.minPayBand.pay_type_id === 2 && this.$_me.minPayBand.value >= 150) {
                    hourPay = `$${numeral(150).format('0')}/hr+`;
                }

                return this.$_me.minPayBand.pay_type_id === 1 ? annualPay : hourPay;
            },

            currentModal() {
                return this.modal.find(o => o.is_active);
            },

            isModalDesiredPay() {
                return this.currentModal.key === 'desired_pay';
            },

            isModalPayComparison() {
                return this.currentModal.key === 'pay_comparison';
            },
        },

        created() {
            this.openModal();
            this.getSalaryEstimation();

            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.back();

                next(false);
            });

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard();
            });
        },

        methods: {
            ...mapActions('common', {
                $_getSalaryEstimation: 'getSalaryEstimation',
            }),

            back() {
                this.closeModal();
            },

            getSalaryEstimation() {
                if (!this.$_workExperience.length) {
                    return false;
                }

                const workExperience = this.$_workExperience[0];

                const data = {
                    jobTitle: workExperience.job_title,
                    occupationId: has(workExperience, 'occupation.id') ? workExperience.occupation.id : '',
                    jobTypeId: has(workExperience, 'jobType.id') ? workExperience.jobType.id : 1,
                    contactTypeId: has(workExperience, 'contractType.id') ? workExperience.contractType.id : 7,
                    locationId: has(workExperience, 'location.id') ? workExperience.location.id : 15299,
                };

                this.spinner.profile_value = true;
                this.$_getSalaryEstimation(data).then((response) => {
                    this.predictedValueCalc(response.data);
                }).finally(() => {
                    this.spinner.profile_value = false;
                });
            },

            predictedValueCalc(data) {
                let annualValue = data.pay_band_max_annually_value;
                let hourValue = data.pay_band_max_hourly_value;

                this.yourPredictedProfileValue = this.$_isPayTypeAnnual ? annualValue : hourValue;

                annualValue = `${numeral(annualValue).format('$0a')}`;
                hourValue = `${numeral(hourValue).format('$0')}/hr`;

                this.yourPredictedProfileValueLabel = this.$_isPayTypeAnnual ? annualValue : hourValue;
            },

            changeToDesiredPay() {
                this.modal.forEach((o) => {
                    o.is_active = o.key === 'desired_pay';
                });
            },

            changeToPayComparison() {
                this.modal.forEach((o) => {
                    o.is_active = o.key === 'pay_comparison';
                });
            },

            close() {
                this.$emit('close');
            },

            openModal() {
                this.isOpen = true;
            },

            closeModal() {
                this.isOpen = false;
                this.close();
            },

            onSeekerPayBandLoading(value) {
                this.spinner.pay_band = value;
            },
        },
    };
